export const environment = {production: true , API:  "https://hspm-apirm.skybox.eco.br/api"  , APIpublic:  "https://hspm-apirm.skybox.eco.br/public/usuario" , AlfrescoAPI:  "https://hspm.skybox.eco.br" , URL_SURFACE:  "https://hspm-surface.skybox.eco.br/" , URL_WORKSPACE:  "https://hspm.skybox.eco.br/" , URL_RM:  "https://hspm-rm.skybox.eco.br/" , siteKeyCapctha:  "6LfJI38oAAAAAF4VIQgqL_LlS9_ZA3uREDLJwYcT" , keyCriptAttempts:  "zRJmF*p4&L9SsP#vKt@yUxQa2WcVbN" }



// WEBPACK FOOTER //
// /app/src/environments/environment.ts